var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexList"},[_vm._l((this.indexList),function(index){return [_c('section',{key:index.id},[_c('h3',[_c('router-link',{staticClass:"g-btn g-btn-lg g-btn-index g-btn-fw",attrs:{"to":_vm._f("lang")('/index/'+index.id)}},[_vm._v(" "+_vm._s(_vm.$t('Index.'+index.id)))])],1)])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }